/* eslint-disable @intlify/vue-i18n/no-raw-text */
<template>
  <div />
</template>

<script lang="ts">
import { defineComponent } from "vue"

import { Settings, SettingsService } from "@/services/rest/utils/SettingsService"

export default defineComponent({
  name: "MatomoView",
  data() {
    return {
      settings: new Settings(),
    }
  },
  created(): void {
    this.plugMatomoIfNeeded()
  },
  methods: {
    async plugMatomoIfNeeded(): Promise<void> {
      this.settings = await SettingsService.INSTANCE.getSettings()
      const matomoURL = "" + this.settings.MATOMO_URL
      const siteId = "" + this.settings.MATOMO_SITE_ID
      if (matomoURL.length > 5 && siteId.length > 1) {
        // @ts-ignore
        const event = new CustomEvent<Settings>("matomo", { detail: this.settings })
        document.dispatchEvent(event)
      }
    },
  },
})
</script>
